import styled, { css } from 'styled-components';

export const Overlay = styled.div<{ $visible: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 500;
  background: #000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transition: opacity 0.4s ease;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
`;

export const Container = styled.div`
  width: 94vw;
  max-width: 1400px;
  text-align: center;
  padding: 10px 0 20px;
  margin: auto;

  @media (max-width: 768px) {
    padding: 70px 16px 30px;
    max-width: 94vw;
  }
`;

export const Title = styled.div`
  font-family: 'Adam', sans-serif;
  font-size: 1.75rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.08em;
  text-shadow: 0 0 20px rgba(0, 200, 255, 0.3);
  margin-bottom: 2px;

  @media (max-width: 768px) {
    font-size: 1.05rem;
    margin-bottom: 8px;
  }
`;

export const ClassRow = styled.div`
  font-family: 'Adam', sans-serif;
  font-size: 1.5rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 10px;
  margin-top: 6px;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

export const ClassValue = styled.span`
  color: #55fde9;
  font-weight: bold;
`;

export const CardsWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
`;

export const Cards = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 768px) {
    gap: 0;
  }
`;

export const Card = styled.div<{ $hidden?: boolean }>`
  flex: 0 0 auto;
  width: 380px;
  text-align: center;
  ${({ $hidden }) => $hidden && 'display: none;'}

  @media (max-width: 768px) {
    width: 280px;
  }
`;

export const Nav = styled.button`
  position: relative;
  flex-shrink: 0;
  width: 50px;
  height: 80px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.25);
  font-size: 2.5rem;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 2;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;

  &:hover {
    color: rgba(0, 220, 255, 0.8);
    text-shadow: 0 0 20px rgba(0, 220, 255, 0.5);
  }

  &:active {
    transform: scale(0.9);
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    width: 40px;
  }
`;

export const Dots = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
`;

export const Dot = styled.div<{ $active?: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: rgba(0, 220, 255, 0.4);
  }

  ${({ $active }) =>
    $active &&
    css`
      background: rgba(0, 220, 255, 0.8);
      box-shadow: 0 0 8px rgba(0, 220, 255, 0.5);
    `}
`;
